export const REVALIDATION_TIME = 60;

export const GOOGLE_VERIFICATION_CODE = 'kdaDHqVi4SM87FHPEZToZDaNgkBFvCYxEWadJ2sU9bQ';

/**
 * Validates and normalizes a URL by ensuring it has a proper protocol
 * @param url - The URL to validate and normalize
 * @returns The normalized URL with proper protocol
 * @throws Error if the URL is invalid
 */
function normalizeUrl(url: string): string {
  if (!url || typeof url !== 'string') {
    throw new Error('Invalid URL: URL must be a non-empty string');
  }

  // Trim whitespace
  const trimmedUrl = url.trim();

  if (!trimmedUrl) {
    throw new Error('Invalid URL: URL cannot be empty');
  }

  // If URL already has a protocol, validate and return as is
  if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
    try {
      new URL(trimmedUrl);
      return trimmedUrl;
    } catch {
      throw new Error(`Invalid URL: ${trimmedUrl}`);
    }
  }

  // For localhost or development environments, default to http
  if (trimmedUrl.includes('localhost') || trimmedUrl.includes('127.0.0.1')) {
    const normalizedUrl = `http://${trimmedUrl}`;
    try {
      new URL(normalizedUrl);
      return normalizedUrl;
    } catch {
      throw new Error(`Invalid localhost URL: ${trimmedUrl}`);
    }
  }

  // For production domains, default to https
  const normalizedUrl = `https://${trimmedUrl}`;
  try {
    new URL(normalizedUrl);
    return normalizedUrl;
  } catch {
    throw new Error(`Invalid production URL: ${trimmedUrl}`);
  }
}

export const DEFAULT_DOMAIN = normalizeUrl(process.env.NEXT_PUBLIC_BASE_URL || 'localhost:80');
